<template lang="html">
  <div class="container">

    <div class="header">
      <p class="select">
        阿米巴项目
        <i class="icon-fanhui iconfont" @click="$router.push({name:'project'})"></i>
        <!-- <i class="iconfont icon-sanjiao"></i> -->
      </p>
    </div>


    <div class="listtxt">
        <h2>{{data.p_name}}</h2>
        <ul>
          <li>
            <p>
              制作部
              <span>{{department[data.group_id]}}</span>
            </p>
          </li>


          <li>
            <p>
              项目状态
              <span>{{complete[data.status]}}</span>
            </p>
          </li>


          <li>
            <p>
              项目金额
              <span>¥{{data.money}}</span>
            </p>
          </li>



          <li>
            <p>
              本周总产值
              <span>¥{{data.value}}</span>
            </p>
          </li>



          <li>
            <p>
              项目总产值
              <span>¥{{data.all_value}}</span>
            </p>
          </li>



          <li>
            <p>
              本周总耗时
              <span>{{data.cost}}</span>
            </p>
          </li>


          <li>
            <p>
              项目总耗时
              <span>{{data.all_cost}}</span>
            </p>
          </li>

          <li>
            <p>
              项目完成度
              <span>{{data.complete == null ? '0' : data.complete}}%</span>
            </p>
          </li>


        </ul>
      </div>



  </div>
</template>

<script>
export default {
  data () {
    return {
      data:{},
      department:{},
      complete:{1:'开发中',2:'已完成'},
    }
  },
  methods:{

  },
  created () {
    this.data = this.$route.params.data
    this.department = this.$route.params.department
  },

}
</script>

<style lang="css" scoped>
  .container {
    height: 100%;
    width: 100%;
    background-color: #fafafa;
    font-family: PingFangSC-Regular;
    overflow: hidden;
  }
  .header{
    width: 100%;
    background: #f5f5f5;
    margin-bottom: 0.21875rem;
  }
  .select{
    width: 100%;
    color: #333333;
    height: 38px;
    background: #fff;
    font-size: 0.40625rem;
    line-height: 1.1875rem;
    padding-left: 0.34375rem;
    position: relative;
    text-align: center;
    border-bottom: 1px solid #ddd;
    margin-bottom: 0.3125rem;
  }
  .iconfont{
    position: absolute;
    left: 0.3125rem;
    font-weight: bold;
    color: #86898E;
    font-size: 0.4375rem;
    line-height: 1.1875rem;
  }
  .listtxt{
    color: #333333;
    width: 100%;
    background: #fff;
    height: 100%;
  }
  .listtxt h2{
    color: #333333;
    width: 100%;
    text-align: center;
    font-size: 0.4375rem;
    margin-bottom: 1.125rem;
    padding-top: 0.4375rem;
  }
  .listtxt ul{
   width: 100%;
  }
  .listtxt ul li{
    height: 0.9375rem;
    line-height: 0.9375rem;
    border-bottom: 1px solid #ddd;
    position: relative;
  }
  .listtxt ul li p{
    color: #333333;
    width: 100%;
    text-align: left;
    font-size: 0.4375rem;
    padding-left: 0.8125rem;
  }.listtxt ul li p{
    color: #333333;
    width: 100%;
    text-align: left;
    font-size: 0.4375rem;
    padding-left: 0.8125rem;
  }
  .listtxt ul li span{
    color: #333333;

    font-size: 0.4375rem;
    position: absolute;
    right: 1.15625rem;
  }


</style>



// WEBPACK FOOTER //
// src/components/ProjectClick.vue